export const AWELL_BRAND_COLOR = '#004ac2'
